import Styles from './NodeTopostman.module.scss';
import { useState, useEffect, useCallback } from 'react';
import ErrorIcon from '@mui/icons-material/Error';

// component imports
import { APIBody } from './TopostComponents/APIBody';
import { APIEnvironmentsTable } from './TopostComponents/APIEnvironmentsTable';
import { APIHeadersTable } from './TopostComponents/APIHeadersTable';
import { LoadingBackdrop } from '../LoadingBackdrop/LoadingBackdrop';
import { useTranslation } from 'components/lib';
// module imports
import {
    Select, MenuItem, TextField, Tabs, Tab, AppBar,
    FormControl, Tooltip, styled, tooltipClasses
} from '@mui/material';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import MonacoEditor from '@monaco-editor/react';
import axios from 'axios';
import _ from 'lodash';


export const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 16,
        fontWeight: 'bolder'
    },
    [`& .MuiTooltip-arrow`]: {
        color: theme.palette.common.white, // Set the arrow color to white
    }
}));


export function NodeTopostman({ apiState, setAPIState, isGraphQL, is_assessment, steps, current, onCompare, onValidate, buttonState, onSendClick, validationState }) {
    const [reqView, setReqView] = useState(0);

    const [httpMethod, setHttpMethod] = useState('');
    const [reqBody, setReqBody] = useState({});
    const [reqHeaders, setReqHeaders] = useState([]);
    const [reqEndpoint, setReqEndpoint] = useState('');

    const [responseCode, setResponseCode] = useState();
    const [responseTime, setResponseTime] = useState();
    const [respBody, setRespBody] = useState({});
    const [environments, setEnvironments] = useState({
        dev: [],
        prod: [],
        qa: []
    });
    const [selectedEnv, setSelectedEnv] = useState('dev');
    const envVars = environments[selectedEnv];

    const [loadingScreen, setLoadingScreen] = useState(false);

    const [showUrlTooltip, setShowUrlTooltip] = useState(false);

    const [isToken, setIsToken] = useState(false)

    let isCompare;
    const [query, setQuery] = useState();
    const [variable, setVariable] = useState();
    const [queryUpdateMsg, setQueryUpdateMsg] = useState(false)
    const [varUpdateMsg, setVarUpdateMsg] = useState(false)
    const endpointToExclude = 'https://graphqlzero.almansi.me/api'

    const { t } = useTranslation();

    const getQuery = (value, e) => {
        setQuery(value);
        setQueryUpdateMsg(true)

    };
    const getVariable = (value, e) => {
        setVariable(value)
        setVarUpdateMsg(true)
    };

    const errorFields = validationState?.isValidated
        ? Object.keys(validationState.validationResults).reduce((acc, key) => {
            if (!validationState.validationResults[key]) acc[key] = true;
            return acc;
        }, {})
        : {};

    const handleSetAPIState = useCallback((newValues) => {
        setAPIState(prevState => ({
            ...prevState,
            ...newValues
        }));
    }, []);


    useEffect(() => {
        handleSetAPIState({
            method: httpMethod
        });
    }, [httpMethod]);

    const onEndpointUpdate = (value) => {
        handleSetAPIState({
            endpoint: value
        });
    };

    const onQueryUpdate = (value) => {
        setQuery(value);
        handleSetAPIState({
            query: value
        });
        setQueryUpdateMsg(false);
    };

    const onVariableUpdate = (value) => {
        setVariable(value);
        try {
            const parsedValue = value ? JSON.parse(value) : {};
            handleSetAPIState({
                variable: parsedValue
            });
        } catch (error) {
            console.error("Invalid JSON in variables:", error);
        }
        setVarUpdateMsg(false);
    };

    useEffect(() => {
        const headersObject = reqHeaders.reduce((acc, header) => {
            const trimmedKey = header.headerKey?.trim() || '';
            const trimmedValue = header.headerValue?.trim() || '';
            if (trimmedKey && trimmedValue) {
                acc[trimmedKey] = trimmedValue;
            }
            return acc;
        }, {});

        handleSetAPIState({
            headers: headersObject
        });
    }, [reqHeaders]);

    useEffect(() => {
        const list = environments?.[selectedEnv] || [];
        const envObject = list.reduce((acc, { key, value }) => {
            if (key && key.trim()) acc[key.trim()] = String(value ?? '');
            return acc;
        }, {});
        handleSetAPIState({ environment: envObject });
    }, [environments, selectedEnv]);

    const onBodyUpdate = (value) => {
        try {
            if (!value || value.trim() === "") {
                handleSetAPIState({ body: "" });
                return;
            }

            const bodyString = typeof value === "string"
                ? value.trim()
                : JSON.stringify(value);

            handleSetAPIState({ body: bodyString });
        } catch (error) {
            console.error("Invalid body:", error);
        }
    };

    const handleValidate = () => {
        if (onValidate) {
            const isValid = onValidate();
            handleSetAPIState({ allCheck: isValid });
        } else {
            const isValid = onCompare();
            handleSetAPIState({ allCheck: isValid });
        }
    };

    useEffect(() => {
        if (respBody?.token) {
            handleSetAPIState({
                generatedToken: respBody.token
            })
            setIsToken(true)
        }
    }, [respBody])

    const handleReqViewChange = (event, newValue) => {
        setReqView(newValue);
    };

    const handleMethodChange = (event) => {
        setHttpMethod(event.target.value);
    };

    const onSend = () => {
        isCompare = onCompare()
        handleSetAPIState({
            allCheck: isCompare
        });
    }


    const handleSend = () => {
        if (onSendClick) {
            onSendClick();
        }
        handleSetAPIState({
            response: -1
        });
        let processedUrl = apiState.endpoint;
        envVars.forEach(({ key, value }) => {
            if (key && value) {
                const pattern = new RegExp(`{{${key}}}`, 'g');
                processedUrl = processedUrl.replace(pattern, value);
            }
        });
        let head = { ...apiState.headers };

        Object.keys(head).forEach(headerKey => {
            let headerValue = head[headerKey];

            envVars.forEach(({ key, value }) => {
                if (key && value) {
                    const pattern = new RegExp(`{{${key}}}`, 'g');
                    headerValue = headerValue.replace(pattern, value);
                }
            });

            head[headerKey] = headerValue;
        });

        const options = {
            method: apiState.method,
            url: processedUrl,
            data: {
                query: query,
                variables: apiState.variable,
            }
        };

        if (Object.keys(head).length > 0) {
            options.headers = head;
            if (!apiState.endpoint.includes(endpointToExclude)) {
                options.headers.aivagam = 'topostman';
            }
        } else {
            options.headers = {}
            if (!apiState.endpoint.includes(endpointToExclude)) {
                options.headers.aivagam = 'topostman';
            }
        }

        if (isGraphQL) {
            options.data = {
                query: query,
                variables: apiState.variable || {}
            };
        } else if (!_.isEqual(apiState.body, {})) {
            try {
                options.data = JSON.parse(apiState.body);
            } catch (error) {
                options.data = apiState.body;
            }
        }
        const startTime = new Date();
        setLoadingScreen(true);

        const axiosInstance = axios.create({
            timeout: 3000, // Timeout set to 1.5 seconds
        });

        axiosInstance
            .request(options)
            .then(function (response) {
                const endTime = new Date();
                setResponseTime(endTime - startTime + 'ms');
                setResponseCode(response.status);
                if (is_assessment) {
                    setRespBody(response.data);

                    handleSetAPIState({ allCheck: true });
                } else {
                    setRespBody(response.data);
                }
                setLoadingScreen(false);
                handleSetAPIState({
                    response: response.status
                });
            })
            .catch((err) => {
                const endTime = new Date();
                console.log(err, err.message)
                setResponseTime(endTime - startTime + 'ms');
                setResponseCode(err.response?.status ? err.response.status : null);
                handleSetAPIState({
                    response: err.response?.status ? err.response.status : null
                });
                setRespBody(is_assessment ? t('Components.NodeLayout.NodeTopostman.message') : err.response?.data ? err.response.data : err.message);
                setLoadingScreen(false);
            });
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(apiState.generatedToken);
        } catch {
            alert(t('Components.NodeLayout.NodeTopostman.alert'));
        }

    };


    return (
        <div id='parentContainer' className={Styles.parentContainer}>
            <LoadingBackdrop isOpen={loadingScreen} />
            <div id='inputContainer' className={Styles.inputContainer}>
                <div id='methodContainer' className={Styles.methodContainer}>
                    <FormControl
                        fullWidth
                        error={errorFields.method}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: errorFields.method ? 'red' : '#ccc',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: errorFields.method ? 'red' : '#999',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: errorFields.method ? 'red' : '#1976d2',
                            },
                        }}
                    >
                        <Select
                            id='httpMethodSelector'
                            value={httpMethod}
                            onChange={handleMethodChange}
                            displayEmpty
                            MenuProps={{ disableScrollLock: true }}
                            renderValue={(selected) => selected || 'NONE'}
                            size="small"
                            sx={{
                                height: '40px',
                                width: '120px',
                                borderRadius: '8px',
                                bgcolor: 'white',
                                '.MuiSelect-select': {
                                    padding: '8px',
                                },
                            }}
                        >
                            <MenuItem value="">NONE</MenuItem>
                            <MenuItem value="GET">GET</MenuItem>
                            <MenuItem value="POST">POST</MenuItem>
                            <MenuItem value="PUT">PUT</MenuItem>
                            <MenuItem value="DELETE">DELETE</MenuItem>
                            <MenuItem value="PATCH">PATCH</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div id='endPointContainer' className={Styles.endPointContainer}>
                    <TextField
                        value={reqEndpoint}
                        id="endpointInput"
                        placeholder={t('Components.NodeLayout.NodeTopostman.placeholder.endpoint')}
                        size="small"
                        fullWidth
                        onChange={(e) => {
                            const newValue = e.target.value;
                            setReqEndpoint(newValue);
                            onEndpointUpdate(newValue);
                        }}
                        error={errorFields.endpoint}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                height: '40px',
                                borderRadius: '8px',
                                bgcolor: 'white',
                                '& fieldset': {
                                    borderColor: errorFields.endpoint ? 'red' : '#ccc',
                                },
                                '&:hover fieldset': {
                                    borderColor: errorFields.endpoint ? 'red' : '#999',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: errorFields.endpoint ? 'red' : '#1976d2',
                                },
                            },
                        }}
                        InputProps={{
                            style: { color: 'black' },
                        }}
                    />
                </div>
                <div id='sendBtnContainer' className={Styles.sendBtnContainer}>
                    <button
                        id='sendBtn'
                        className={Styles.sendBtn}
                        onClick={handleSend}
                        disabled={buttonState?.sendDisabled || false}
                        title={apiState.endpoint.length === 0 ? t('Components.NodeLayout.NodeTopostman.tooltip.send') : ''}
                    >
                        {t('Components.NodeLayout.NodeTopostman.button')}
                    </button>
                    <LightTooltip
                        title={t('Components.NodeLayout.NodeTopostman.tooltip.validate')}
                        arrow
                        placement="top"
                        classes={{
                            tooltip: {
                                backgroundColor: '#fff',
                                color: 'rgba(0, 0, 0, 0.87)',
                                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
                                fontSize: 11,
                            },
                        }}
                    >
                        <button
                            id="validateBtn"
                            className={Styles.validateBtn}
                            onClick={handleValidate}
                            disabled={buttonState?.validateDisabled || false}
                        >
                            {t('Components.NodeLayout.NodeTopostman.validateBtn')}
                        </button>
                    </LightTooltip>
                </div>
            </div>
            <div id='reqDetailsContainer' className={Styles.reqDetailsContainer} >
                {!isGraphQL && <AppBar
                    position="static"
                    sx={{
                        bgcolor: 'transparent',
                        borderRadius: '8px',
                        boxShadow: 'none'
                    }}
                >
                    <Tabs
                        value={reqView}
                        onChange={handleReqViewChange}
                        variant="fullWidth"
                        aria-label={t('Components.NodeLayout.NodeTopostman.aria.tabs')}
                        TabIndicatorProps={{
                            sx: {
                                backgroundColor: 'green',
                                height: 3,
                            }
                        }}
                    >
                        <Tab
                            id="headersTable"
                            label={
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    {t('Components.NodeLayout.NodeTopostman.tab.headers')}
                                    {errorFields.headers && (
                                        <ErrorIcon sx={{ color: 'red', fontSize: 22 }} />
                                    )}
                                </div>
                            }
                            sx={{
                                width: '30px',
                                color: 'slategrey',
                                transition: 'color 0.5s ease-in-out',
                                '&.Mui-selected': {
                                    color: 'black',
                                },
                            }}
                        />
                        <Tab
                            id="bodyTable"
                            label={
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    {t('Components.NodeLayout.NodeTopostman.tab.body')}
                                    {errorFields.body && (
                                        <ErrorIcon sx={{ color: 'red', fontSize: 22 }} />
                                    )}
                                </div>
                            }
                            sx={{
                                width: '30px',
                                color: 'slategrey',
                                transition: 'color 0.5s ease-in-out',
                                '&.Mui-selected': {
                                    color: 'black',
                                },
                            }}
                        />
                        <Tab
                            id="envTable"
                            label={
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    {t('Components.NodeLayout.NodeTopostman.tab.env')}
                                    {errorFields.environment && (
                                        <ErrorIcon sx={{ color: 'red', fontSize: 22 }} />
                                    )}
                                </div>
                            }
                            sx={{
                                width: '30px',
                                color: 'slategrey',
                                transition: 'color 0.5s ease-in-out',
                                '&.Mui-selected': {
                                    color: 'black',
                                },
                            }}
                        />

                    </Tabs>
                </AppBar>}
                {!isGraphQL && <div id='requestInteractContainer' className={Styles.requestInteractContainer}>
                    <div className={Styles.reqInteraction} hidden={reqView !== 0} >
                        {reqView === 0 &&
                            <APIHeadersTable
                                setReqHeaders={setReqHeaders}
                                reqHeaders={reqHeaders}

                            />
                        }
                    </div>

                    <div className={Styles.reqInteraction} hidden={reqView !== 1}>
                        {reqView === 1 &&
                            <APIBody
                                isResponse={false}
                                setReqBody={setReqBody}
                                reqBody={reqBody}
                                onUpdateClick={onBodyUpdate}
                            />
                        }
                    </div>
                    <div className={Styles.reqInteraction} hidden={reqView !== 2}>
                        {reqView === 2 &&
                            <APIEnvironmentsTable
                                envVars={envVars}
                                setEnvVars={(newVars) =>
                                    setEnvironments(prev => ({ ...prev, [selectedEnv]: newVars }))
                                }
                                setEnvironments={setEnvironments}

                                environments={environments}
                                currentEnv={selectedEnv}
                                setCurrentEnv={setSelectedEnv}
                                isDisabled={false}
                            />
                        }
                    </div>
                </div>}

                {isGraphQL &&
                    <div className={Styles.graphQLparent}>
                        <AppBar
                            position="static"
                            sx={{
                                bgcolor: 'transparent',
                                borderRadius: '8px',
                                boxShadow: 'none'
                            }}
                        >
                            <Tabs
                                value={reqView}
                                onChange={handleReqViewChange}
                                variant="fullWidth"
                                aria-label="full width tabs example"
                                TabIndicatorProps={{
                                    sx: {
                                        backgroundColor: 'green',
                                        height: 3,
                                    }
                                }}
                            >
                                <Tab
                                    id="query"
                                    label={t('Components.NodeLayout.NodeTopostman.tab.query')}
                                    sx={{
                                        width: '30px',
                                        color: 'slategrey',
                                        transition: 'color 0.5s ease-in-out',
                                        '&.Mui-selected': {
                                            color: 'black',
                                        },
                                    }}
                                />
                                <Tab
                                    id="variables"
                                    label={t('Components.NodeLayout.NodeTopostman.tab.variables')}
                                    sx={{
                                        width: '30px',
                                        color: 'slategrey',
                                        transition: 'color 0.5s ease-in-out',
                                        '&.Mui-selected': {
                                            color: 'black',
                                        },
                                    }}
                                />
                            </Tabs>
                        </AppBar>
                        <div className={Styles.interaction}>
                            {reqView === 0 &&
                                <div className={Styles.queryInteraction}>
                                    <div className={Styles.schema}>
                                        {steps[current].schema}
                                    </div>
                                    <div className={Styles.query}
                                        style={{
                                            backgroundColor: 'white',
                                            borderRadius: '8px',
                                            border: '1px solid #ccc',
                                            overflow: 'hidden'
                                        }}>
                                        <MonacoEditor
                                            width='37vw'
                                            height='33vh'
                                            value={apiState.query || ''}
                                            theme="vs-light"
                                            defaultLanguage="graphql"
                                            defaultValue={t('Components.NodeLayout.NodeTopostman.placeholder.query')}
                                            onChange={onQueryUpdate}
                                            options={{
                                                minimap: { enabled: false },
                                                fontSize: 16,
                                                wordWrap: "on",
                                            }}
                                        />
                                    </div>
                                </div>}
                            {reqView === 1 &&
                                <div className={Styles.variableIntercation}
                                    style={{
                                        backgroundColor: 'white',
                                        borderRadius: '8px',
                                        border: '1px solid #ccc',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <MonacoEditor
                                        width='100vw'
                                        height='33vh'
                                        value={
                                            typeof apiState.variable === 'object'
                                                ? JSON.stringify(apiState.variable, null, 2)
                                                : apiState.variable || ''
                                        }
                                        theme="vs-light"
                                        defaultLanguage="json"
                                        defaultValue={t('Components.NodeLayout.NodeTopostman.placeholder.variables')}
                                        onChange={onVariableUpdate}
                                        options={{
                                            minimap: { enabled: false },
                                            fontSize: 16,
                                            wordWrap: "on",
                                            scrollBeyondLastLine: false,
                                            automaticLayout: true,
                                        }}
                                    />
                                </div>}
                        </div>
                    </div>
                }
            </div>
            <div id='respDetailsContainer' className={Styles.respDetailsContainer}>
                <div id='responseTitle' className={Styles.responseTitle}>
                    <div id='responseContainer' className={Styles.responseContainer}>
                        <p id='resopnseTitle' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            {t('Components.NodeLayout.NodeTopostman.tab.response')}
                            {errorFields.response && (
                                <ErrorIcon sx={{ color: 'red', fontSize: 22 }} />
                            )}
                        </p>
                        <TextField
                            id='generatedToken'
                            placeholder={t('Components.NodeLayout.NodeTopostman.placeholder.token')}
                            value={apiState.generatedToken.length > 0 ? apiState.generatedToken : ''}
                            size="small"
                            sx={{
                                height: '60%',
                                borderRadius: '8px',
                                bgcolor: 'white'
                            }}
                            InputProps={{
                                style: { color: 'black' },
                                readOnly: true
                            }}
                        />
                        <button id='copyTokenBtn' className={Styles.tokenButton} disabled={isToken ? false : true} onClick={handleCopy} >
                            <Tooltip title={t('Components.NodeLayout.NodeTopostman.tooltip.token')} arrow placement='right' open={isToken}>
                                <ContentCopyIcon
                                    size="small"
                                    sx={{
                                        color: isToken ? 'black' : 'lightgrey'
                                    }}
                                />
                            </Tooltip>
                        </button>

                    </div>

                    <div
                        id='respDetails'
                        className={Styles.respDetails}
                        style={{
                            color: responseCode <= 400 ? '#6BDD7B' : '#dd6b6b'
                        }}
                    >
                        <p title={t('Components.NodeLayout.NodeTopostman.tooltip.status')}>
                            {responseCode}
                        </p>
                        <p title={t('Components.NodeLayout.NodeTopostman.tooltip.response')}>
                            {responseTime}
                        </p>
                    </div>
                </div>
                <APIBody isResponse={true} reqBody={respBody} />
            </div >
        </div >
    );
}